/**
 * The Sort Operations
 */
export enum NextSortOperation {
  ON = 1,
  OFF,
  SWITCH
}
